import { cn, getStatusBorderColor, getStatusColor } from "@theprelude/core";

export function NonApplicablePercent() {
  return (
    <div
      className={
        "flex w-max flex-col border border-stroke-line p-4 text-secondary-foreground"
      }
    >
      <span className="font-medium text-sm">Protected</span>
      <span className="text-4xl">N/A</span>
      <span className="text-xs">No results</span>
    </div>
  );
}

export const ProtectedPercent: React.FC<{
  percent: number | null | undefined;
}> = ({ percent }) => {
  if (percent === null || percent === undefined) {
    return <NonApplicablePercent />;
  }
  const textColor = getStatusColor(percent);
  const borderColor = getStatusBorderColor(percent);

  return (
    <div className={cn("flex flex-col gap-2", textColor)}>
      <div
        className={cn(
          "flex w-max flex-col border border-stroke-line p-4",
          borderColor,
        )}
      >
        <span className="font-medium text-sm">Protected</span>
        <span className="text-4xl">{percent}%</span>
      </div>
    </div>
  );
};

export const BenchmarkPercent: React.FC<{
  social: number | null | undefined;
}> = ({ social }) => {
  return (
    <div className="flex w-max flex-col">
      <span className="text-secondary-foreground text-xs">Benchmark</span>
      <span className="text-primary-foreground text-xl">
        {social === null || social === undefined ? "Unavailable" : `${social}%`}
      </span>
    </div>
  );
};
